export function isWithinTimeRange() {
    const currentTime = new Date();
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();

    // 判断是否在 21:20 到 21:50 之间
    if (hours === 21 && minutes >= 20 && minutes <= 50) {
        return true;
    }

    return false;
}
